import { render, staticRenderFns } from "./darkTag.vue?vue&type=template&id=2f802b37&scoped=true"
import script from "./darkTag.vue?vue&type=script&lang=js"
export * from "./darkTag.vue?vue&type=script&lang=js"
import style0 from "./darkTag.vue?vue&type=style&index=0&id=2f802b37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f802b37",
  null
  
)

export default component.exports